import type { AuthenticatedUser } from '@/api/auth';
import './UserBadge.css';

export interface UserBadgeProps {
  user: AuthenticatedUser;
  onLogout: () => void;
}

export default function UserBadge({ user, onLogout }: UserBadgeProps) {
  return (
    <div className="user-badge">
      {user.picture && <img src={user.picture} alt="" className="user-badge-avatar" />}
      <span className="user-badge-name">{user.name}</span>
      <button type="button" className="user-badge-logout" onClick={onLogout}>
        Logout
      </button>
    </div>
  );
}
